import { API } from './axios';

export const getApplicantDetails = async (id) => {
  try {
    const res = await API.get(
      `/applicants?filters[user][id][$eq]=${id}&sort=createdAt:desc&pagination[limit]=1&populate=*`
    );
    localStorage.setItem('applicant', res.data.data[0].applicationStatus);
    return res.data.data[0]; // array of applicant entries
  } catch (err) {
    console.error('Failed to fetch applicant', err);
    return null;
  }
};
